<template>
  <div class="patata" @click="goUrl()">
    <v-row style="margin-left: 5px;margin-right: 5px">
      <v-col cols="9">
        <div> <b style="color: var(--v-primary-base)">{{ $t('From') }} </b> : {{ from.name }} {{ from.surname }}</div>
        <div> {{ msg }}</div>
      </v-col>
      <v-col cols="3" style="align-self: center;text-align: right">
        {{ hourFormat }}
        {{ dateFormat }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
export default {
    name: "NotificationItemList",
    props: {
        from: {type: Object, default: null},
        to: {type: Object, default: null},
        msg: {type: String, default: ''},
        url: {type: String, default: ''},
        date: {type: String, default: null}
    },
    data () {
        return {
            dateFormat: moment(String(this.date)).format("DD/MM/YYYY"),
            hourFormat: moment(String(this.date)).format("HH:mm:ss")
        };
    },
    methods: {
        goUrl () {
            if (this.url !== '') {
                window.location.href = this.url;
            }
        }
    }
};
</script>

<style scoped>

</style>
